/* :: Import Dependencies
{+} ---------------------------------- */
import gsap from 'gsap';
import ScrollMagic from 'scrollmagic';
import './util/animation.gsap';

/* :: Set Globals
{+} ---------------------------------- */
global.greensock = gsap;
global.ScrollMagic = ScrollMagic;

/* :: Import Local
{+} ---------------------------------- */
import Router from './util/Router';
import core from './bootstrap';

/* :: Router Setup
{+} ---------------------------------- */
const routes = new Router({
    core
});

/* :: Load!
{+} ---------------------------------- */
function ready(callbackFunc) {
    if (document.readyState !== 'loading') {
        // Document is already ready, call the callback directly
        callbackFunc();
    } else if (document.addEventListener) {
        // All modern browsers to register DOMContentLoaded
        document.addEventListener('DOMContentLoaded', callbackFunc);
    } else {
        // Old IE browsers
        document.attachEvent('onreadystatechange', () => {
            if (document.readyState === 'complete') {
                callbackFunc();
            }
        });
    }
}

ready(routes.loadEvents());
